
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes ,Router} from 'react-router-dom';
import React, { Component } from 'react';
import Login from './/Components/login'
import Dashboard from './/Components/dashboard'
import Register from './/Components/register'
import UsersData from './/Components/viewUsers'
import ErrorPage from './/Components/404'
import ProtectedRoute from './/Components/protectedRoutes'
import { ScrollContext } from 'react-router-scroll-4';
import AddBids from './/Components/addBids';
import ViewBids from './Components/viewBids';

class App extends Component {
  render() { 
    return (
 
     <Routes>

      <Route exact path={`${process.env.PUBLIC_URL}/`}     element={<Login />} /> 
      <Route path={`${process.env.PUBLIC_URL}/dashboard`}  element={<Dashboard />}/> 
      <Route path={`${process.env.PUBLIC_URL}/create-user`}   element={<Register />}/> 
      <Route path={`${process.env.PUBLIC_URL}/view-users`}  element={<UsersData />}/> 
      <Route path={`${process.env.PUBLIC_URL}/add-bids`}  element={<AddBids />}/> 
      <Route path={`${process.env.PUBLIC_URL}/view-bids`}  element={<ViewBids />}/>
    

      <Route exact path="/"  element={<Login />} /> 
      <Route exact path="/create-user" element={<Register />} /> 
      <Route exact path="/view-users" element={<UsersData />} /> 
      <Route  path="/dashboard"  element={<Dashboard />}/> 
      <Route path="/add-bids"  element={<AddBids />}/> 
      <Route path="/view-bids"  element={<ViewBids />}/> 
      <Route path="/error"  element={<ErrorPage />}/>    

      {/* <Route path='/AddBids'  element={<AddBids />}/>  */}
      {/* <Route path="*" element={<ErrorPage />}/>*/  }

      
    </Routes>
    
     
   
    );
  }
}
 
export default App;

